    <script type="text/ecmascript-6">
    import DesignerQuestionHardwareJoiningBolt from "../DesignerQuestionHardwareJoiningBolt.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareJoiningBolt
        ],
        computed: {
            panel_required(){
                return true;
            },
        },
    }
</script>
